import React from "react";
import './LoadingPage.scss';

const LoadingPage = () => (
  <div className="loader">
    <div className="loader__spinner"></div>
  </div>
);

export default LoadingPage;
